// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"379":"cfdb9f8f","655":"715db717"}[chunkId] + ".chunk.css";
};